// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IContributionRecordBulkUpdateRequestDto,
  IContributionRecordUpdateRequestDto,
} from '../models/index';
import {
    IContributionRecordBulkUpdateRequestDtoFromJSON,
    IContributionRecordBulkUpdateRequestDtoToJSON,
    IContributionRecordUpdateRequestDtoFromJSON,
    IContributionRecordUpdateRequestDtoToJSON,
} from '../models/index';

export interface UpdateAllContributionRecordsRequest {
    requestId: string;
    ifMatch: number;
    iContributionRecordBulkUpdateRequestDto: IContributionRecordBulkUpdateRequestDto;
}

export interface UpdateContributionRecordsRequest {
    requestId: string;
    ifMatch: number;
    iContributionRecordUpdateRequestDto: Array<IContributionRecordUpdateRequestDto>;
}

/**
 * ContributionUpdateControllerApi - interface
 * 
 * @export
 * @interface ContributionUpdateControllerApiInterface
 */
export interface ContributionUpdateControllerApiInterface {
    /**
     * 
     * @summary Update all contribution records in a request with the same values
     * @param {string} requestId 
     * @param {number} ifMatch Numeric version (ETag) of contribution request
     * @param {IContributionRecordBulkUpdateRequestDto} iContributionRecordBulkUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionUpdateControllerApiInterface
     */
    updateAllContributionRecordsRaw(requestParameters: UpdateAllContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update all contribution records in a request with the same values
     */
    updateAllContributionRecords(requestParameters: UpdateAllContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update contribution records for a request (batch)
     * @param {string} requestId 
     * @param {number} ifMatch Numeric version (ETag) of contribution request
     * @param {Array<IContributionRecordUpdateRequestDto>} iContributionRecordUpdateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionUpdateControllerApiInterface
     */
    updateContributionRecordsRaw(requestParameters: UpdateContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update contribution records for a request (batch)
     */
    updateContributionRecords(requestParameters: UpdateContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ContributionUpdateControllerApi extends runtime.BaseAPI implements ContributionUpdateControllerApiInterface {

    /**
     * Update all contribution records in a request with the same values
     */
    async updateAllContributionRecordsRaw(requestParameters: UpdateAllContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling updateAllContributionRecords().'
            );
        }

        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling updateAllContributionRecords().'
            );
        }

        if (requestParameters['iContributionRecordBulkUpdateRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iContributionRecordBulkUpdateRequestDto',
                'Required parameter "iContributionRecordBulkUpdateRequestDto" was null or undefined when calling updateAllContributionRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/{request_id}/contribution-records/update-all`;
        urlPath = urlPath.replace(`{${"request_id"}}`, encodeURIComponent(String(requestParameters['requestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: IContributionRecordBulkUpdateRequestDtoToJSON(requestParameters['iContributionRecordBulkUpdateRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update all contribution records in a request with the same values
     */
    async updateAllContributionRecords(requestParameters: UpdateAllContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAllContributionRecordsRaw(requestParameters, initOverrides);
    }

    /**
     * Update contribution records for a request (batch)
     */
    async updateContributionRecordsRaw(requestParameters: UpdateContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling updateContributionRecords().'
            );
        }

        if (requestParameters['ifMatch'] == null) {
            throw new runtime.RequiredError(
                'ifMatch',
                'Required parameter "ifMatch" was null or undefined when calling updateContributionRecords().'
            );
        }

        if (requestParameters['iContributionRecordUpdateRequestDto'] == null) {
            throw new runtime.RequiredError(
                'iContributionRecordUpdateRequestDto',
                'Required parameter "iContributionRecordUpdateRequestDto" was null or undefined when calling updateContributionRecords().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['ifMatch'] != null) {
            headerParameters['If-Match'] = String(requestParameters['ifMatch']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/contributions/contribution-requests/{request_id}/contribution-records`;
        urlPath = urlPath.replace(`{${"request_id"}}`, encodeURIComponent(String(requestParameters['requestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['iContributionRecordUpdateRequestDto']!.map(IContributionRecordUpdateRequestDtoToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update contribution records for a request (batch)
     */
    async updateContributionRecords(requestParameters: UpdateContributionRecordsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateContributionRecordsRaw(requestParameters, initOverrides);
    }

}
